import React, { useState } from "react";
import { useRouter } from "next/router";

import ArrowIcon from "@/shared/components/ArrowIcon/ArrowIcon";
import Button from "@/shared/components/Button/Button";

import useUiLanguagesTranslated from "@/hooks/useUiLanguagesTranslated";
import { getOptionKey } from "@/shared/utils/select";
import LangPopup from "../Book/LangPopup";
import { LANDING_SELECTORS } from "@/utils/landing/landing.constants";
import { BUTTON_VARIANT } from "@/shared/components/Button/Button.constants";
import classNames from "classnames";

const LanguageUISelector = ({ render = "full", className, onClick }) => {
  const router = useRouter();
  const [isOpenLangModal, setIsOpenLangModal] = useState(false);

  const uiLanguagesTranslated = useUiLanguagesTranslated("next");
  const currentLang = uiLanguagesTranslated.find((item) => getOptionKey(item) === router.locale);

  const handleClickLanguage = (id) => {
    if (onClick) onClick();

    setIsOpenLangModal(false);
    router.push({ pathname: router.pathname, query: router.query }, router.asPath, { locale: id });
  };

  return (
    <div data-lang-wrapper style={{display: "flex"}}>
      <Button
        onClick={() => setIsOpenLangModal(true)}
        paddingLess
        variant={BUTTON_VARIANT.clear}
        className={classNames(LANDING_SELECTORS.langUIBtn.substring(1), className)}>
        {render === "full" && (
          <>
            <span>{currentLang.label}</span>
            <ArrowIcon direction={isOpenLangModal ? "down" : "right"} />
          </>
        )}

        {render === "small" && <span> {currentLang.key} </span>}
      </Button>

      <LangPopup
        title={"uiLanguage"}
        langs={uiLanguagesTranslated}
        isOpen={isOpenLangModal}
        setIsOpen={setIsOpenLangModal}
        onClickItem={handleClickLanguage}
        classNameModal={LANDING_SELECTORS.langUIDialogRootClass.substring(1)}
      />
    </div>
  );
};

export default LanguageUISelector;
